<script setup>
import { maskStr, post } from '@/common/util'
import { useMetaStore } from '@/stores'
import _ from 'lodash-es'
import { reactive } from 'vue'
const props=defineProps(['ttl','tkey','refnm','refid','ownermid','targettype','auth','targettypes']),emits=defineEmits(['closePop','saveCallback']),metaStore=useMetaStore()
,meta=reactive({seladdmems:[],selected:[],simplemems:[]})
,save=async()=>{
  meta.isloading=true
  const pms=meta.tarmems.map(tm=>({refnm:props.refnm,refid:props.refid,ownerid:props.ownermid,targetmid:tm.targetmid}))
  if(pms.length==0)pms.push({refnm:props.refnm,refid:props.refid,ownerid:props.ownermid,etc:'onlydelete'})
  const res=await post('rest/authed/admin/resettarmems',pms)
  metaStore.toastRslt(res,true)
  if(res.isSuccess)emits('saveCallback',meta.targettype)
  meta.isloading=false
},add=()=>{
  meta.seladdmems.forEach(sel => {
    if(!meta.tarmems.some(tm=>tm.targetmid==sel.targetmid))meta.tarmems.push(sel)
  })
  meta.simplemems=meta.simplemems.filter(mm=>!meta.seladdmems.some(tm=>tm.targetmid==mm.targetmid))
  meta.seladdmems=[]
},del=()=>{
  meta.tarmems.filter(tm=>meta.selected.includes(tm.targetmid)).forEach(mem=>meta.simplemems.push(mem))
  meta.tarmems=meta.tarmems.filter(tm=>!meta.selected.includes(tm.targetmid))
  meta.selected=[]
},init=async()=>{
  meta.simplemems=[]
  const auths=props.auth.split(',')
  for(let auth of auths){
    const res=await post('rest/authed/admin/simplemems',{authorities:auth})
    _.entries(res.data).forEach(ent=>meta.simplemems.push({targetmid:ent[0],mname:ent[1]}))
  }
  const pms={refnm:props.refnm}
  if(props.refid)pms.refid=props.refid
  meta.tarmems=await post('rest/authed/admin/tarmems',pms)
  meta.tarmems=meta.tarmems.data
  if(!meta.tarmems)meta.tarmems=[]
  const mids=meta.tarmems.map(mm=>mm.targetmid)
  meta.tarmems=meta.simplemems.filter(mm=>mids.includes(mm.targetmid))
  meta.simplemems=meta.simplemems.filter(mm=>!mids.includes(mm.targetmid))
  meta.inited=true
}
meta.targettype=props.targettype?props.targettype:'all'
init()
</script>
<template>
  <v-card v-if="meta.inited" width="450">
    <v-card-title>
      <v-row>
        <v-col>{{props.tkey?metaStore.t(props.tkey):props.ttl}}</v-col>
        <v-col class="text-right">
          <v-btn density="compact" icon="mdi-close" @click="emits('closePop')"/>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card class="text-caption pa-2 ma-4 bg-grey-lighten-4">
      <div>{{$t('checkitout')}}</div>
      <div>{{$t('youcanaddupto10usersatatime')}}</div>
    </v-card>
    <v-select v-if="props.targettypes" class="ms-4 me-4" variant="outlined" density="compact" :label="$t('access_setting')" :items="props.targettypes" v-model="meta.targettype" :item-title="$t"
      :item-value="val=>val"/>
    <v-row class="ms-1">
      <v-col>
        <v-combobox hide-details multiple chips variant="outlined" density="compact" :label="$t('newregistration')" :items="meta.simplemems"
          :item-title="item=>`${item.mname}(${maskStr(item.targetmid)})`" item-value="mid" :disabled="meta.targettype!='partial'||_.isEmpty(meta.simplemems)" v-model="meta.seladdmems"
           @update:model-value="selusers=>{
            const filtered=selusers.filter(item => typeof item !== 'string')
            if(filtered.length>10){
              metaStore.toast('최대 10명까지 등록 가능합니다.',false)
              filtered.splice(10)
            }
            meta.seladdmems=filtered
          }"/>
      </v-col>
      <v-col cols="3" class="text-end pe-7">
        <v-btn color="secondary" :text="$t('add')" :disabled="meta.targettype!='partial'||_.isEmpty(meta.simplemems)" @click="add"/>
      </v-col>
    </v-row>
    <v-card-text>
      <v-card>
        <v-card-text>
          <div>{{ props.tkey?metaStore.t(props.tkey):props.ttl+' '+metaStore.t('lists') }}</div>
          <v-list height="250" v-model:selected="meta.selected" lines="one" select-strategy="leaf" :disabled="meta.targettype!='partial'">
            <v-list-item v-for="item in meta.tarmems" :title="`${item.mname}(${maskStr(item.targetmid)})`" :value="item.targetmid"/>
          </v-list>
        </v-card-text>
      </v-card>
    </v-card-text>
    <v-card-actions>
      <v-row class="ps-2 pe-2">
        <v-col>
          <v-btn variant="elevated" :text="$t('refresh')" :disabled="meta.targettype!='partial'" @click="init" class="me-4"/>
          <v-btn variant="elevated" color="error" :text="$t('delete')" :disabled="meta.targettype!='partial'" @click="del"/>
        </v-col>
        <v-col class="text-right">
          <v-btn variant="elevated" class="me-3" :text="$t('cancel')" @click="emits('closePop')"/>
          <v-btn variant="elevated" color="primary" :text="$t('save')" @click="save"/>
        </v-col>
      </v-row>
    </v-card-actions>
    <v-overlay :model-value="meta.isloading" class="align-center justify-center" persistent contained>
      <v-progress-circular color="primary" size="64" indeterminate/>
    </v-overlay>
  </v-card>
</template>
